// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-widget-button[data-v-2ab3a942]{padding:8px;height:35px;font-weight:700;cursor:pointer;border-radius:20px;outline:none;color:#fff;text-align:center;width:130px}.user-widget-button--clickadilla[data-v-2ab3a942]{background:#9ed04d}.user-widget-button--vast-service[data-v-2ab3a942]{background:linear-gradient(180deg,#19cecc,#0ca5e9)}", ""]);
// Exports
module.exports = exports;
